import { render, staticRenderFns } from "./OrbitRemoveOwnerConfirmStep.vue?vue&type=template&id=6487c403&scoped=true"
import script from "./OrbitRemoveOwnerConfirmStep.vue?vue&type=script&lang=ts"
export * from "./OrbitRemoveOwnerConfirmStep.vue?vue&type=script&lang=ts"
import style0 from "./OrbitRemoveOwnerConfirmStep.vue?vue&type=style&index=0&id=6487c403&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6487c403",
  null
  
)

export default component.exports